import React from "react";

const MyAccountHeader = () => {
  return (
    <div className="page_heading mb-5">
      <h1 className="position-relative pb-4 text-uppercase">My Account</h1>
    </div>
  );
};

export default MyAccountHeader;
